import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
const QuoteInformation = ({ title, text, secondText, styleTitle, styleSummary, }) => (<View style={styles.container}>
    <Text Text-14 style={styleTitle} flex>
      {title}
    </Text>
    {text ? (<Text TextThin-14 numberOfLines={2} style={[styleSummary]}>
        {text}
      </Text>) : null}
    {secondText ? (<Text TextThin-14 numberOfLines={2} style={[styleSummary]}>
        {secondText}
      </Text>) : null}
  </View>);
const styles = StyleSheet.create({
    container: {
        marginTop: rem(5),
        marginBottom: rem(5),
        flexDirection: 'row',
        columnGap: 10,
    },
});
export default memo(QuoteInformation);
